export default {
    namespaced: true,
    state: {
        messages: [
        /*
          {
              messageId: string,
              message: string
          }
         */
        ]
    },
    getters: {
        messages(state) {
            return state.messages
        }
    },
    mutations: {
        loadState(state) {
            const messages = localStorage.getItem("nishika.temporary_state.messages")
            if (messages) {
                state.messages = JSON.parse(messages)
            }
        },
        updateMessage(state, {messageId, message}) {
            const msg = state.messages.find(item => item.messageId === messageId)
            if (msg) {
                msg.message = message
            } else {
                state.messages.push({
                    messageId, message
                })
            }
            localStorage.setItem("nishika.temporary_state.messages", JSON.stringify(state.messages))
        },
        removeMessage(state, {messageId}) {
            state.messages = state.messages.filter(item => item.messageId !== messageId)
            localStorage.setItem("nishika.temporary_state.messages", JSON.stringify(state.messages))
        }
    },
    actions: {
        load({commit}) {
            commit("loadState")
        },
        saveMessage({commit}, {messageId, message}) {
            commit("updateMessage", {messageId, message})
        },
        deleteMessage({commit}, {messageId}) {
            commit("removeMessage", {messageId})
        }
    }
}
